import { useEffect, useState } from "react";
import { ActivityItem, clearActivity, loadActivity, subscribeActivity } from "./activity";
import { formatWhen } from "./later";
import { Selection } from "./useChatData";

const KIND_LABEL: Record<ActivityItem["kind"], string> = {
  message: "New message",
  mention: "Mentioned you",
  "channel-created": "Channel created",
  "added-to-channel": "Added to channel",
};

/** The "Activity" rail tab — new messages, mentions, and channel events,
 * logged while dbm. chat is open in this browser (see activity.ts). */
export default function ActivityPanel({
  onClose,
  onOpen,
}: {
  onClose: () => void;
  onOpen: (s: Selection) => void;
}) {
  const [items, setItems] = useState<ActivityItem[]>(loadActivity);

  useEffect(() => subscribeActivity(() => setItems(loadActivity())), []);

  const open = (conversation?: ActivityItem["conversation"]) => {
    if (!conversation) return;
    onOpen({
      kind: conversation.kind,
      id: conversation.id,
      name: conversation.name,
      subtitle: conversation.kind === "group" ? "Channel" : "Direct message",
    });
    onClose();
  };

  return (
    <aside className="details-panel later-panel">
      <div className="modal-head">
        <b>Activity</b>
        <button className="hbtn" onClick={onClose} aria-label="Close">✕</button>
      </div>

      <div className="modal-section">
        <div className="modal-list">
          {items.length === 0 && <div className="sect-empty">Nothing yet — new messages and channel events show up here</div>}
          {items.map((i) => (
            <div className="later-item" key={i.id}>
              <button className="later-item__main" onClick={() => open(i.conversation)} disabled={!i.conversation}>
                <span className="later-item__text">
                  <b>{KIND_LABEL[i.kind]}</b>
                  {i.from ? ` · ${i.from}` : ""}
                </span>
                <span className="later-item__meta">
                  {i.text}
                  {i.conversation ? ` — ${i.conversation.kind === "group" ? "#" : ""}${i.conversation.name}` : ""}
                  {" · "}
                  {formatWhen(i.at)}
                </span>
              </button>
            </div>
          ))}
        </div>
      </div>

      {items.length > 0 && (
        <div className="later-note">
          <button className="edit-cancel" style={{ padding: 0 }} onClick={clearActivity}>
            Clear activity
          </button>
        </div>
      )}
    </aside>
  );
}
